module.exports = __webpack_public_path__ + "media/images/ligweb_img_not_found-666a6d635a854b8aa64bcb027307cd06.jpg";